import { render, staticRenderFns } from "./languageArchive.vue?vue&type=template&id=2593ad8c&"
import script from "./languageArchive.vue?vue&type=script&lang=js&"
export * from "./languageArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports